import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpEventType, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { ProfileImageUpload } from "../../shared/models/ProfileImageUpload";
// import { FileUploadService } from 'src/app/services/file-upload.service';
import { FileUploadService } from "../../shared/service/fileUpload.service";
import { Profile_File_Types } from "../../shared/UploadFileTypes";
import { dataService } from "../../shared/service/dataservice.service";

@Component({
  selector: "app-edit-avatar",
  templateUrl: "./edit-avatar.component.html",
  styleUrls: ["./edit-avatar.component.scss"],
})
export class EditAvatarComponent implements OnInit {
  profileImageUpload: any;
  MAX_SIZE: number = 1048576;

  @ViewChild("avatarImg", { static: true }) avatarImgElement: ElementRef;

  @Input() photo: string;
  @Input() empCode: any;
  @Input() EmpCode: any;
  @Input() NamePerRecords: any;
  @Output() photoUpdated = new EventEmitter<string>();
  @Input() isProfile: boolean;

  showAddPhotoOverlay = false;
  imageInfos?: Observable<any>;
  FileAsBase64: string | ArrayBuffer;

  constructor(
    private uploadService: FileUploadService,
    private file_Svc: FileUploadService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private dataservice: dataService
  ) {
    this.route.params.subscribe((params) => {
      this.empCode = params["empCode"];
    });
  }

  ngOnInit(): void {
    this.profileImageUpload = new ProfileImageUpload();
    this.uploadService
      .getUserProfileDetails(this.empCode)
      .subscribe((data: any) => {
        this.imageInfos = data.Base64Profile || data.ProfileFilePath;
        this.photo = data.Base64Profile || data.ProfileFilePath;
        this.photoUpdated.emit(this.photo);
      });
  }

  addPhoto(event) {
    const fileReader = new FileReader();
    if (event.target.files == undefined) {
      this.profileImageUpload = null;
    }
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      if (!this.validFileType(files[0])) {
        this.toastr.warning(
          "File name " + files[0].name + ": Not a valid file type."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
      //  Don't allow file sizes over 1MB
      if (files[0].size < this.MAX_SIZE) {
        fileReader.onload = () => {
          this.avatarImgElement.nativeElement.src = fileReader.result;
          this.FileAsBase64 = fileReader.result.toString();
          this.profileImageUpload = this.file_Svc
            .profileUpload(
              files,
              this.avatarImgElement.nativeElement.src,
              this.empCode
            )
            .subscribe((data: any) => {
              this.uploadService
                .getUserProfileDetails(this.empCode)
                .subscribe((data: any) => {
                  this.imageInfos = data.Base64Profile || data.ProfileFilePath;
                  this.photo = data.Base64Profile || data.ProfileFilePath;
                  this.photoUpdated.emit(this.photo);
                });
            });
        };
      } else {
        this.toastr.warning(
          " File: " +
            files[0].name +
            " exceeds 1MB hence it cannot be uploaded."
        );
        //  Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
    }
    fileReader.readAsDataURL(event.target.files[0]);
  }

  validFileType(file) {
    let types = Profile_File_Types;
    return types.includes(file.type);
  }

  openFileInput(fileInput) {
    fileInput.click();
    this.showAddPhotoOverlay = false;
  }

  downloadProfilePic() {
    this.uploadService
      .getUserProfileDetails(this.empCode)
      .subscribe((data: any) => {
        const EmpCode = this.empCode.trim();
        const NamePerRecords = this.NamePerRecords.trim();
        const filename = `${EmpCode}-${NamePerRecords}`;

        var url = this.file_Svc.downloadImage(data.Base64Profile, filename);
      });

    // window.open(url);
  }

  removePhoto() {
    this.avatarImgElement.nativeElement.src = "";
    this.photo = "";
    this.photoUpdated.emit(this.photo);
  }

  getHrEmpDtlsOutput(val) {}
}
